module.exports = __webpack_public_path__ + "img/step2.edea2b8.png";